export default __webpack_public_path__ + "img/b7895a62eb0533bed09707f6779149df.svg";